import { render, staticRenderFns } from "./ProjectOverviewCard.vue?vue&type=template&id=bea92368&scoped=true&"
import script from "./ProjectOverviewCard.vue?vue&type=script&lang=js&"
export * from "./ProjectOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOverviewCard.vue?vue&type=style&index=0&id=bea92368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea92368",
  null
  
)

export default component.exports